export default __webpack_public_path__ + "static/media/logo_white.b1545ee7.svg";